export default __webpack_public_path__ + "static/media/ham-burger.9317d7e2.jpg";